import React, { useEffect, useState } from "react";
import binanceLogo from "../../images/binanceLogo.png";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import dollarIco from "../../images/dollarIco.png";
import api from "../../api";
import { Loader } from "../global/loader";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useMediaQuery } from "@mui/material";

const coinList = [
  {
    symbol: "BTC",
  },
  {
    symbol: "ETH",
  },
  {
    symbol: "SOL",
  },
];

export const LiquidationData = () => {
  const [selectedCoin, setSelectedCoin] = useState("BTC");
  const [LiquidationData, setLiquidationData] = useState({});
  const [chartDAta, setChartData] = useState([]);
  const [loader, setLoader] = useState(true);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const isSmall = useMediaQuery("(max-width:768px)");

  const getMarketLiquidity = async () => {
    try {
      let payload = {
        symbol: selectedCoin,
      };
      setLoader(true);
      const resp = await api.getLiquidationData(payload);
      // console.log(resp);
      if (resp?.liquidation?.exchanges) {
        setLiquidationData(resp?.liquidation?.exchanges);
        const chartData1 = Object.keys(resp?.liquidation?.exchanges).map(
          (key) => {
            const total =
              resp?.liquidation?.exchanges[key].longs +
              resp?.liquidation?.exchanges[key].shorts;
            return {
              name:
                key === "binance_futures"
                  ? "Binance Futures"
                  : key.charAt(0).toUpperCase() + key.slice(1),
              value: total,
            };
          }
        );
        const filtered = chartData1.filter(
          (d) => d.name == "Binance Futures" || d.name == "Bybit"
        );
        setChartData(filtered);
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  function getTotalLongShort(data) {
    let totalLong = 0;
    let totalShort = 0;

    for (const exchange in data) {
      const { longs = 0, shorts = 0 } = data[exchange];
      totalLong += longs;
      totalShort += shorts;
    }

    return {
      totalLong: Math.round(totalLong),
      totalShort: Math.round(totalShort),
      total: Math.round(totalLong + totalShort),
    };
  }

  useEffect(() => {
    getMarketLiquidity();
  }, [selectedCoin]);

  const COLORS = ["#384ef4", "#b060ed", "#16a34a", "#f59e0b"];

  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2">Liquidations by Exchange</h5>

        <div className="expand">
          <button
            className=" dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={`${baseUrl}/icon/${selectedCoin.toLowerCase()}.svg`}
              alt="icon"
              width={"27px"}
              style={{ marginRight: 10 }}
            />
            {selectedCoin}
          </button>
          <ul className="dropdown-menu">
            <div className="coinSelector">
              {coinList.map((item, key) => (
                <div
                  className="coin"
                  onClick={() => setSelectedCoin(item.symbol)}
                  key={key}
                >
                  <img
                    loading="lazy"
                    width="20"
                    src={`${baseUrl}/icon/${item.symbol.toLowerCase()}.svg`}
                    srcSet={`${baseUrl}/icon/${item.symbol.toLowerCase()}.svg`}
                    alt=""
                  />
                  <div className="name">{item.symbol}</div>
                </div>
              ))}
            </div>
          </ul>
        </div>
      </div>
      <div className="descrip mb-2">
        24-hour liquidation data expressed in US dollars ($) with detailed
        breakdown by exchange.
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 mb-3">
          <div className="lCard">
            <div className="logo">
              <img src={binanceLogo} alt="binance" />
            </div>
            <div className="content">
              <div className="title">
                {selectedCoin || "ETH"} - Binance Futures
              </div>
              <div className="long">
                $
                {(LiquidationData?.binance_futures?.longs &&
                  formatNumber(LiquidationData?.binance_futures?.longs)) ||
                  0}
              </div>
              <div className="short">
                $
                {(LiquidationData?.binance_futures?.shorts &&
                  formatNumber(LiquidationData?.binance_futures?.shorts)) ||
                  0}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 mb-3">
          <div className="lCard">
            <div className="logo">
              <img src={bybitLogo} alt="binance" />
            </div>
            <div className="content">
              <div className="title">
                {selectedCoin || "ETH"} - Bybit Futures
              </div>
              <div className="long">
                $
                {(LiquidationData?.bybit?.longs &&
                  formatNumber(LiquidationData?.bybit?.longs)) ||
                  0}
              </div>
              <div className="short">
                $
                {(LiquidationData?.bybit?.shorts &&
                  formatNumber(LiquidationData?.bybit?.shorts)) ||
                  0}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-sm-6">
          <div className="lCard">
            <div className="logo">
              <img src={bitmexLogo} alt="binance" />
            </div>
            <div className="content">
              <div className="title">{selectedCoin || "ETH"} - BitMex</div>
              <div className="long">${LiquidationData?.bitmex?.longs || 0}</div>
              <div className="short">
                ${LiquidationData?.bitmex?.shorts || 0}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-sm-6">
          <div className="lCard">
            <div className="logo">
              <img src={okxLogo} alt="binance" />
            </div>
            <div className="content">
              <div className="title">{selectedCoin || "ETH"} - OKX</div>
              <div className="long">${LiquidationData?.okx?.longs || 0}</div>
              <div className="short">${LiquidationData?.okx?.shorts || 0}</div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-sm-6">
          <div className="lCard">
            <div className="logo">
              <img src={bitfinexLogo} alt="binance" />
            </div>
            <div className="content">
              <div className="title">{selectedCoin || "ETH"} - BitFinex</div>
              <div className="long">
                ${LiquidationData?.bitfinex?.longs || 0}
              </div>
              <div className="short">
                ${LiquidationData?.bitfinex?.shorts || 0}
              </div>
            </div>
          </div>
        </div> */}
        <div className="col-lg-4 col-md-6 mb-3">
          <div className="lCard">
            <div className="logo">
              <img src={dollarIco} alt="binance" />
            </div>
            <div className="content">
              <div className="title">Total Liquidated Amount</div>
              <div className="long">
                $
                {(getTotalLongShort(LiquidationData)?.totalLong &&
                  formatNumber(
                    getTotalLongShort(LiquidationData)?.totalLong
                  )) ||
                  0}
              </div>
              <div className="short">
                $
                {(getTotalLongShort(LiquidationData)?.totalShort &&
                  formatNumber(
                    getTotalLongShort(LiquidationData)?.totalShort
                  )) ||
                  0}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="chartMain">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart className="mx-auto">
            <Pie
              data={chartDAta}
              cx="50%"
              cy="50%"
              innerRadius={30}
              outerRadius={isSmall ? 100 : 120}
              fill="#b060ed"
              paddingAngle={5}
              dataKey="value"
              label={isSmall ? false : true}
              className="mx-auto"
            >
              {chartDAta.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {loader && <Loader />}
    </div>
  );
};
